import { IDirectoryTree } from '../types/directory-tree';
import { IDirectory } from '@/api/directories/types/directory';

export class DirectoryTreeHelper {
  static buildDirectoryTree = (
    directories: IDirectoryTree[],
    newDirectory: IDirectoryTree
  ): IDirectoryTree[] => {
    return directories.map(({ id, title, directory, children }: IDirectoryTree) => {
      if (title === newDirectory.title && directory === newDirectory.directory) {
        return newDirectory;
      }
      const newChildren: IDirectoryTree[] = DirectoryTreeHelper.buildDirectoryTree(
        children,
        newDirectory
      );
      return {
        id,
        title,
        directory,
        children: newChildren,
      };
    });
  };

  static buildDirectoryTreeWithChildren = (
    directories: IDirectory[],
    subDirectories: IDirectory[][]
  ): IDirectoryTree[] => {
    const mergedSubs: IDirectory[] = [].concat(...subDirectories);
    return directories.map(
      (dir: IDirectory): IDirectoryTree => {
        const child: IDirectoryTree = {
          id: dir.id,
          title: dir.title,
          directory: dir.directory,
          children: [],
        };
        child.children = mergedSubs.reduce(
          (filtered: IDirectoryTree[], sub: IDirectory): IDirectoryTree[] => {
            if (sub.directory === `${dir.directory}${dir.title}/`) {
              const subChild = {
                id: sub.id,
                title: sub.title,
                directory: sub.directory,
                children: [],
              };
              filtered.push(subChild);
            }
            return filtered;
          },
          []
        );
        return child;
      }
    );
  };

  static convertDirectoryType(path: string, branches: IDirectoryTree[]): IDirectory[] {
    return branches.reduce((filtered: IDirectory[], branch: IDirectoryTree): IDirectory[] => {
      if (branch.directory === path) {
        filtered.push({
          id: branch.id,
          title: branch.title,
          directory: branch.directory,
        });
      }
      const children: IDirectory[] = DirectoryTreeHelper.convertDirectoryType(
        path,
        branch.children
      );
      children.forEach((child: IDirectory) => {
        filtered.push(child);
      });
      return filtered;
    }, []);
  }

  static expandDirectory = (
    tree: IDirectoryTree,
    depth: number,
    activeDirectory: string
  ): boolean => {
    let result = false;
    if (depth === 0) {
      result = true;
    } else {
      const directories = activeDirectory.split('/');
      directories.pop();
      result = directories[depth] === tree.title ? true : false;
    }
    return result;
  };
}
